function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawCalling = function UndrawCalling(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1145.7 770.58",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 736.47,
    y1: 828.46,
    x2: 736.47,
    y2: 482.14,
    gradientTransform: "matrix(-1 0 0 1 1540 0)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("ellipse", {
    cx: 771.85,
    cy: 760.58,
    rx: 142,
    ry: 10,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1145.7 454.1a268.06 268.06 0 0 1-310.49 264.52H410.5A364.06 364.06 0 0 1 361 722q-17.83 0-35.23-1.7A360.62 360.62 0 0 1 0 361C0 161.62 161.63 0 361 0c160.57 0 296.63 104.84 343.52 249.8a266.84 266.84 0 0 1 173.33-63.6c147.91 0 267.85 119.94 267.85 267.9z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1042.79 665.17a268.31 268.31 0 0 1-207.58 53.45H410.5A364.06 364.06 0 0 1 361 722q-17.83 0-35.23-1.7a361.17 361.17 0 0 1-309-250.21c34.58-73.89 123.42-126.47 227.58-126.47 101.5 0 188.5 49.94 224.81 120.87a301.82 301.82 0 0 1 54.19-4.87c105.2 0 194.77 53.67 228.59 128.67a295.63 295.63 0 0 1 86.41-12.71c85.8.04 161.21 35.71 204.44 89.59z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M351.7 673.23c0 25.62-9.83 39.53-25.93 47.07a359.07 359.07 0 0 1-169-61.58 97.08 97.08 0 0 1 7.33-25.25l45.79 14.24-40.78-24a98.13 98.13 0 0 1 20.85-24.94l76.93 23.92-60.27-35.4A98 98 0 0 1 345.91 640l.21.6c.16.45.32.9.47 1.36q.81 2.39 1.49 4.83c.17.58.33 1.16.47 1.75s.29 1.12.42 1.68.24 1 .34 1.46c.07.3.14.6.2.9.11.48.21 1 .3 1.45.14.7.28 1.41.4 2.11s.25 1.46.36 2.19.24 1.62.34 2.44.18 1.46.25 2.19c0 .23.05.45.07.68.07.64.12 1.28.17 1.92a2.11 2.11 0 0 1 0 .25q.09 1.2.15 2.4t.09 2.34a1.69 1.69 0 0 1 0 .23c.05.8.06 1.62.06 2.45z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M351.7 673.23c0 25.62-9.83 39.53-25.93 47.07a358.43 358.43 0 0 1-113.44-30.24l1.64-1.09c7.41-4.91 15.07-9.93 23.79-11.6 7.67-1.47 15.58-.23 23.37-.67a54.67 54.67 0 0 0 35.81-16.41c5.57-5.76 10-12.83 16.65-17.23 7.22-4.74 16.38-5.76 24.94-4.58a66.11 66.11 0 0 1 7.38 1.51l.21.6c.16.45.32.9.47 1.36q.81 2.39 1.49 4.83c.17.58.33 1.16.47 1.75s.29 1.12.42 1.68.24 1 .34 1.46c.07.3.14.6.2.9.11.48.21 1 .3 1.45.14.7.28 1.41.4 2.11s.25 1.46.36 2.19.24 1.62.34 2.44.18 1.46.25 2.19c0 .23.05.45.07.68.07.64.12 1.28.17 1.92a2.11 2.11 0 0 1 0 .25q.09 1.2.15 2.4t.09 2.34a1.69 1.69 0 0 1 0 .23c.05.81.06 1.63.06 2.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M935.5 689.86a37 37 0 0 1-.8 7.76c-.1.48-.21.95-.32 1.41-2.84 11.39-10.85 19.72-20.41 20.25h-1c-10.11 0-18.66-8.72-21.48-20.73-.08-.32-.15-.64-.22-1a37 37 0 0 1-.8-7.76c0-16.27 10.07-29.45 22.5-29.45s22.53 13.25 22.53 29.52z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M935.5 689.86a37 37 0 0 1-.8 7.76c-.1.48-.21.95-.32 1.41h-1a45.76 45.76 0 0 1-7.36-1 44.92 44.92 0 0 1-6.56 1.5 45.87 45.87 0 0 1-5.14.48h-1.74a46.41 46.41 0 0 1-6.16-.41 45.17 45.17 0 0 1-9.67-2.4 45.56 45.56 0 0 1-5.22 1.4c-.08-.32-.15-.64-.22-1a37 37 0 0 1-.8-7.76c0-16.27 10.07-29.45 22.5-29.45s22.49 13.2 22.49 29.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M983.5 635a45.54 45.54 0 0 0-4.9-20.61l-26.46 8.23 23.23-13.65a45.71 45.71 0 0 0-34.36-19.59 45.65 45.65 0 0 0-3.57-4.72l-38 11.83 31.17-18.33a45.73 45.73 0 0 0-72 24.39l32.55 37.47-35.31-25.54a45.74 45.74 0 0 0 40.93 80.7 45.92 45.92 0 0 0 29.28.81 45.78 45.78 0 0 0 55.57-44.7c0-1 0-2-.1-3A45.63 45.63 0 0 0 983.5 635z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M982.71 643.48a121.9 121.9 0 0 0-42.34-.54c-15.89 2.63-32.13 8.41-47.67 4.19-9.12-2.48-17-8.22-25.91-11.41a49.18 49.18 0 0 0-26.75-1.6 45.76 45.76 0 0 0 56.69 61.06 45.92 45.92 0 0 0 29.28.81 45.78 45.78 0 0 0 55.62-44.7c0-1 0-2-.1-3a45.19 45.19 0 0 0 1.18-4.81z",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 706.95,
    y: 250.42,
    width: 8.86,
    height: 73.02,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 412.51,
    y: 193.21,
    width: 4.97,
    height: 24.04,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 412.33,
    y: 237.23,
    width: 5.6,
    height: 41.84,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 412.42,
    y: 293.71,
    width: 5.33,
    height: 42.2,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 415.33,
    y: 113.77,
    width: 296.4,
    height: 602.39,
    rx: 38.99,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 534.94,
    y: 131.76,
    width: 41.39,
    height: 8.4,
    rx: 3.87,
    fill: "#e6e8ec"
  }), React.createElement("circle", {
    cx: 587.35,
    cy: 135.96,
    r: 4.77,
    fill: "#e6e8ec"
  }), React.createElement("path", {
    d: "M669.85 129.46h-33.9v4.09a19.38 19.38 0 0 1-19.38 19.38H508.39a19.38 19.38 0 0 1-19.38-19.38v-4.09h-31.84A23.53 23.53 0 0 0 433.64 153v523.93a23.53 23.53 0 0 0 23.53 23.54h212.68a23.54 23.54 0 0 0 23.54-23.54V153a23.54 23.54 0 0 0-23.54-23.54z",
    fill: primaryColor
  }), React.createElement("path", {
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1,
    d: "M444.53 223.47h149v24h-149z"
  }), React.createElement("circle", {
    cx: 480.53,
    cy: 355.47,
    r: 32,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M471.53 349.47v12h8l10 10.45v-32.91l-10 10.46z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 565.53,
    cy: 355.47,
    r: 32,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M565.53 368.83a3.82 3.82 0 1 0 3.8 3.82 3.82 3.82 0 0 0-3.8-3.82zm-11.2-34.36a3.82 3.82 0 1 0 3.79 3.82 3.82 3.82 0 0 0-3.79-3.82zm0 11.46a3.82 3.82 0 1 0 3.79 3.81 3.81 3.81 0 0 0-3.79-3.81zm0 11.45a3.82 3.82 0 1 0 3.79 3.82 3.82 3.82 0 0 0-3.79-3.82zm22.4-15.27a3.82 3.82 0 1 0-3.8-3.82 3.81 3.81 0 0 0 3.8 3.82zm-11.2 15.27a3.82 3.82 0 1 0 3.8 3.82 3.82 3.82 0 0 0-3.8-3.82zm11.2 0a3.82 3.82 0 1 0 3.8 3.82 3.82 3.82 0 0 0-3.8-3.82zm0-11.45a3.82 3.82 0 1 0 3.8 3.81 3.81 3.81 0 0 0-3.8-3.81zm-11.2 0a3.82 3.82 0 1 0 3.8 3.81 3.81 3.81 0 0 0-3.8-3.81zm0-11.46a3.82 3.82 0 1 0 3.8 3.82 3.82 3.82 0 0 0-3.8-3.82z",
    fill: "#fff"
  }), React.createElement("g", {
    opacity: 0.4
  }, React.createElement("circle", {
    cx: 480.53,
    cy: 451.47,
    r: 32,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M495.53 453.47h-13v13h-4v-13h-13v-4h13v-13h4v13h13z",
    fill: "#fff"
  })), React.createElement("circle", {
    cx: 650.53,
    cy: 355.47,
    r: 32,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M650.53 335.96a18.24 18.24 0 0 0-18 18.48v14.37a6.08 6.08 0 0 0 6 6.16h6v-16.51h-8v-4a14 14 0 1 1 28 0v4h-8v16.5h6a6.07 6.07 0 0 0 6-6.16v-14.36a18.24 18.24 0 0 0-18-18.48z",
    fill: "#fff"
  }), React.createElement("g", {
    opacity: 0.4
  }, React.createElement("circle", {
    cx: 565.53,
    cy: 451.47,
    r: 32,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M577.53 448.04v-8a2.31 2.31 0 0 0-2.34-2.28h-28.34a2.31 2.31 0 0 0-2.33 2.28v22.81a2.32 2.32 0 0 0 2.33 2.28h28.33a2.32 2.32 0 0 0 2.34-2.28v-8l9 9.12v-25.05z",
    fill: "#fff"
  })), React.createElement("circle", {
    cx: 650.53,
    cy: 451.47,
    r: 32,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M648.95 459.71a11.44 11.44 0 0 1-11.29 0c-4.42 1.35-7.13 5.82-8.13 9.75h27.55c-1-3.93-3.7-8.4-8.13-9.75zm-5.64-21a9.93 9.93 0 1 0 9.92 9.92 9.92 9.92 0 0 0-9.92-9.92zm0 17.48a7.66 7.66 0 0 1-6.94-4.74h13.87a7.66 7.66 0 0 1-6.93 4.75z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M656.77 463.46h14.76a12.28 12.28 0 0 0-8.13-9 11.47 11.47 0 0 1-5.65 1.49 11.25 11.25 0 0 1-3.9-.66 13.47 13.47 0 0 1-2.62 3.28 12.77 12.77 0 0 1 5.54 4.89zm-1.5-17.25h9.42a7.66 7.66 0 0 1-6.94 4.72 7.26 7.26 0 0 1-2.38-.42 12 12 0 0 1-.61 2.35 9.93 9.93 0 1 0 3-19.39 9.94 9.94 0 0 0-8.37 4.6 12.25 12.25 0 0 1 5.88 8.14z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 565.53,
    cy: 579.47,
    r: 32,
    fill: "#ff6f61"
  }), React.createElement("path", {
    d: "M549.1 587.37a23.61 23.61 0 0 1 5.91-4.08 1.87 1.87 0 0 0 1.11-1.74l.17-6.22a30.06 30.06 0 0 1 18.66.5l-.17 6.22a2.07 2.07 0 0 0 1 1.8 21.9 21.9 0 0 1 5.82 4.4 2 2 0 0 0 2.83.08l5.08-4.82a2 2 0 0 0 .08-2.82 34 34 0 0 0-48.07-1.3 2 2 0 0 0-.07 2.83l4.81 5.08a2 2 0 0 0 2.83.07z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 654.53,
    cy: 243.47,
    r: 25,
    stroke: primaryColor,
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M660.18 249.08a11.46 11.46 0 0 1-11.3 0c-4.42 1.35-7.13 5.82-8.13 9.76h27.56c-1-3.94-3.71-8.41-8.13-9.76zm-5.65-21a9.93 9.93 0 1 0 9.92 9.93 9.94 9.94 0 0 0-9.92-9.93zm0 17.49a7.68 7.68 0 0 1-6.94-4.74h13.88a7.7 7.7 0 0 1-6.94 4.75z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M404.58 66.39c-2.33-1.35-5.48-.06-7.08 2.11s-2 5-2.45 7.63c-.89 5.91-1.54 12.7 2.45 17.16-6.52-19.77-25.27-34.92-46-37.13M808.61 392.64c-1.5-.87-3.52 0-4.55 1.36a10.83 10.83 0 0 0-1.58 4.9c-.57 3.81-1 8.17 1.58 11a35.86 35.86 0 0 0-29.55-23.87M299.11 263.36c-1.5-.86-3.52 0-4.55 1.36a10.83 10.83 0 0 0-1.58 4.91c-.57 3.8-1 8.16 1.58 11a35.88 35.88 0 0 0-29.55-23.87",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M724 795.68c1 1.89 2.88 3.05 4.69 4.08a222.68 222.68 0 0 0 39.56 17.81 2.64 2.64 0 0 0 3.84-1.49c1.58-2.66 3.31-7 2.9-10.51a5.86 5.86 0 0 0 2.63-3.52 17.5 17.5 0 0 1 2.44-5c1.87-2.82 4.13-5.65 4.43-9.08a15.67 15.67 0 0 1 .35-3.64c.53-1.58 1.94-2.62 3-3.88 1.65-2 2.44-4.58 3.19-7.09 3.12-10.43 6.24-20.86 8.84-31.45.84-3.43 1.62-6.87 2.77-10.2 1-2.92 2.28-5.72 3.55-8.52A226.25 226.25 0 0 1 822 693.87a78.48 78.48 0 0 0 3.39 9.24c.68 1.55 1.41 3.08 2.1 4.63 2.61 5.84 2.14 13.34 5.35 18.83q2 3.38 3.94 6.75a13.59 13.59 0 0 1 1.69 3.57c.21.88.23 1.8.38 2.69.68 4 3.93 6.82 5.73 10.39 1.65 3.26 2 7 3 10.59 2.37 8.3 8.19 15.51 8.78 24.16a62.39 62.39 0 0 1-.17 7 59.36 59.36 0 0 0 .81 12.18 4.68 4.68 0 0 0 .32 1.18 35.34 35.34 0 0 1-22 14.86c-1.7.34-3.65.7-4.54 2.26-1.07 1.86.14 4.42 2 5.42s4 .9 6 .72a217.9 217.9 0 0 0 42.37-7.82 3.61 3.61 0 0 0 1.84-1 3.71 3.71 0 0 0 .61-2.49 21 21 0 0 0-2.2-9.31l1-.35c.56-4-1.5-7.87-3.1-11.58-2.78-6.47-4.3-13.46-6.5-20.19-4.24-13-11.09-25.13-12.74-38.73-.45-3.74-1.57-7.54-1.81-11.3-.48-7.66-1-15.36-2.67-22.82-1.4-6.14-3.61-12-5-18.21s-1.84-12.74.2-18.68c.58-1.7 1.36-3.31 1.89-5 2-6.61.09-13.77-1.85-20.41q-.92-3.15-1.82-6.28c-.81-2.75-1.61-5.51-2.49-8.24.12-.11.23-.22.35-.35 1.76-2 1.74-5.06 3-7.45.62-1.23 1.56-2.24 2.22-3.44a12.6 12.6 0 0 0 .91-8.34c-.53-2.8-1.59-5.46-2.39-8.19a44.52 44.52 0 0 1-.48-23c.81-3.23 2-6.4 2.17-9.73a28.38 28.38 0 0 0-.61-6.63c-1.55-8.4-4.59-16.92-10.76-22.47-3.29-3-7.74-5.63-8.09-10.19a2.55 2.55 0 0 0-1.66-.06 17.84 17.84 0 0 1-.56-3.17h.05a4.09 4.09 0 0 0 .92 0 1.83 1.83 0 0 0 .74-.21 2.11 2.11 0 0 0 .36-.27 6.51 6.51 0 0 0 1-1.33c.41-.68.78-1.41 1.09-1.91s.81-1.3 1.2-2q1.75-3 3.25-6.1v-.08c.1-.19.19-.39.28-.58l.12-.27.18-.41c0-.1.09-.21.13-.31s.11-.25.16-.38l.14-.33c.05-.12.09-.24.14-.37a3.42 3.42 0 0 0 .13-.34c.05-.12.09-.24.13-.36s.08-.23.13-.35.07-.24.11-.36l.12-.36c0-.12.06-.23.1-.35l.1-.37.09-.35.09-.38c0-.11 0-.22.07-.34s0-.26.07-.39 0-.22 0-.33l.06-.39v-.33-.4-.33-.63-.41-.3-.42-.28a7.93 7.93 0 0 0-.23-1.16 11.93 11.93 0 0 0-3.92-5.93 24.55 24.55 0 0 0-6-3.61A4.38 4.38 0 0 1 830 489a11.12 11.12 0 0 1-1.19-2.24c-.88-1.54-2.64-2.23-4.29-2.64s-3.42-.67-4.8-1.72a1.27 1.27 0 0 0-.42-.24 1.09 1.09 0 0 0-.61.13l-3.85 1.71a1.83 1.83 0 0 0-2.12-1.51 5.13 5.13 0 0 0-2.49 1.43.93.93 0 0 1-.23-.92l-3 2c-.37.24-1.05.3-1-.16a31.28 31.28 0 0 0-4.31 6 12.88 12.88 0 0 0-.94 2.07c0 .15-.09.3-.13.45a.29.29 0 0 0 0 .09c0 .13-.06.27-.08.41a.5.5 0 0 0 0 .12v.52a5.49 5.49 0 0 0 0 .58 3.19 3.19 0 0 0 1.73 2.66 3.08 3.08 0 0 0 1.2.19 15.48 15.48 0 0 0 2.54-.52 5.86 5.86 0 0 1 .82-.14 2.56 2.56 0 0 1 .39 0 2.21 2.21 0 0 1 1.44.49l.06.06a16.83 16.83 0 0 0-7 13.79 17.34 17.34 0 0 0 1.76 7.64 2.43 2.43 0 0 0-1.25 2.26 7.68 7.68 0 0 1-.41-2.38c-1.64-.33-2.83 1.59-3.42 3.24a80.53 80.53 0 0 0-2.81 11.41c-.51 2.57-1 5.14-1.52 7.71s-1 5.33-1.38 8a61 61 0 0 0 .93 20.79c-.1.22-.19.45-.28.67-.3.8-1.15 1.48-1.25 2.33-.54 5.09 2.68 9.68 5.72 13.67a3 3 0 0 0 1 1 2.7 2.7 0 0 0 1.41.18 36.07 36.07 0 0 0 3.62-.36c.07.68.15 1.35.23 2 .86 7.18 2.33 14.36 2.32 21.59s-1.38 14.56 1.39 21c.46 1.1 1.35 2 1.44 3.14h.17a65.29 65.29 0 0 0-4.14 10.74c-1.1 4.34-1.33 8.9-2.56 13.2-1.05 3.65-2.8 7-4.21 10.56a58 58 0 0 0-4 18.11 22.63 22.63 0 0 1-1.7 8.31 84.53 84.53 0 0 0-4.24 9.77c-2 5.94-5.37 11.57-6 17.86-.35 3.56.16 7.36-1.33 10.58-.58 1.26-1.44 2.35-2.12 3.54a28.61 28.61 0 0 0-2.31 6l-9.9 32.83a10.72 10.72 0 0 1-2.42 4.87c-.92.88-2.13 1.36-3 2.27-1.4 1.42-1.75 3.5-1.76 5.62a11.8 11.8 0 0 0-3.06 1 33.71 33.71 0 0 1-26.49 0c-1.6-.69-3.42-1.51-5-.72-1.85.96-2.15 3.75-1.15 5.64zM802.87 547a21.55 21.55 0 0 1 3.28-7.59c2.24-3.69 4.6-7.34 6.74-11.11l.61-.59c.17.48.33 1 .48 1.45a34.91 34.91 0 0 1 .89 3.9 18.79 18.79 0 0 1 .28 5l-.14.11a5.33 5.33 0 0 0-1.89 2.11 4.25 4.25 0 0 0 0 2.64l-.09.1.1-.07c.35 1.38 1 2.8.79 4.2-.23 1.69-1.59 2.92-2.44 4.37-2 3.49-1.36 8.79-4.65 10.93l-.06.14a4.74 4.74 0 0 1-3.23-2.66c.26-4.27-1.34-8.65-.67-12.93z",
    transform: "translate(-27.15 -64.71)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M857.76 752.51a3.47 3.47 0 0 1-.63 2.45 3.89 3.89 0 0 1-1.92 1 238.61 238.61 0 0 1-44.14 7.72c-2.14.16-4.4.28-6.29-.71s-3.15-3.52-2-5.35c.93-1.54 3-1.9 4.73-2.23a37 37 0 0 0 23.16-15 10.74 10.74 0 0 1 2.52-2.92c1.92-1.31 4.47-1 6.74-.55 4 .82 9.31 1.79 12.92 3.75s4.85 8.01 4.91 11.84z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M857.76 752.51a3.47 3.47 0 0 1-.63 2.45 3.89 3.89 0 0 1-1.92 1 238.61 238.61 0 0 1-44.14 7.72c-2.14.16-4.4.28-6.29-.71s-3.15-3.52-2-5.35c.93-1.54 3-1.9 4.73-2.23a37 37 0 0 0 23.16-15 10.74 10.74 0 0 1 2.52-2.92c1.92-1.31 4.47-1 6.74-.55 4 .82 9.31 1.79 12.92 3.75s4.85 8.01 4.91 11.84z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M741.55 751.54a3.55 3.55 0 0 1-1.87 1.72 3.83 3.83 0 0 1-2.13-.25 238.82 238.82 0 0 1-41.22-17.57c-1.88-1-3.84-2.16-4.89-4s-.73-4.67 1.2-5.6c1.62-.78 3.52 0 5.18.71a36.9 36.9 0 0 0 27.6 0 10.69 10.69 0 0 1 3.71-1.08c2.31-.05 4.3 1.58 6 3.21 2.92 2.87 6.83 6.58 8.79 10.18s-.34 9.43-2.37 12.68z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M741.55 751.54a3.55 3.55 0 0 1-1.87 1.72 3.83 3.83 0 0 1-2.13-.25 238.82 238.82 0 0 1-41.22-17.57c-1.88-1-3.84-2.16-4.89-4s-.73-4.67 1.2-5.6c1.62-.78 3.52 0 5.18.71a36.9 36.9 0 0 0 27.6 0 10.69 10.69 0 0 1 3.71-1.08c2.31-.05 4.3 1.58 6 3.21 2.92 2.87 6.83 6.58 8.79 10.18s-.34 9.43-2.37 12.68z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M817.77 560.04c1.49 4 2.74 8 4 12l1.9 6.2c2 6.55 4 13.61 1.93 20.14-.55 1.69-1.36 3.28-2 5-2.12 5.86-1.63 12.37-.21 18.44s3.72 11.9 5.18 18c1.77 7.36 2.28 15 2.78 22.51.25 3.71 1.41 7.46 1.89 11.15 1.72 13.41 8.85 25.43 13.27 38.21 2.29 6.63 3.87 13.52 6.78 19.91 1.66 3.66 3.81 7.45 3.23 11.42-8.13 2.88-17.14 2.83-24.8-1.12a2.54 2.54 0 0 1-1.68-2.33 55.19 55.19 0 0 1-.8-12 58.54 58.54 0 0 0 .17-6.88c-.61-8.53-6.68-15.64-9.14-23.84-1-3.49-1.46-7.22-3.18-10.44-1.88-3.52-5.26-6.33-6-10.25-.16-.88-.18-1.78-.39-2.65a13.28 13.28 0 0 0-1.77-3.53l-4.08-6.69c-3.35-5.42-2.86-12.82-5.57-18.58-.72-1.53-1.49-3-2.2-4.56a76.37 76.37 0 0 1-3.53-9.12 218.24 218.24 0 0 0-16.5 28.89 89.74 89.74 0 0 0-3.7 8.41c-1.2 3.28-2 6.68-2.89 10.06-2.7 10.45-6 20.74-9.21 31-.78 2.48-1.61 5-3.32 7-1.1 1.24-2.56 2.26-3.12 3.83a14.71 14.71 0 0 0-.36 3.58c-.32 3.39-2.67 6.18-4.62 9a16.89 16.89 0 0 0-2.54 5 5.86 5.86 0 0 1-8 3.75h-.08a17.58 17.58 0 0 1-2.28-1.36 42.13 42.13 0 0 1-5.37-4 31 31 0 0 1-4-4.72 2.28 2.28 0 0 1 1.14-3.46c-.21-2.78-.27-5.95 1.73-7.87.93-.9 2.19-1.38 3.15-2.24a10.4 10.4 0 0 0 2.52-4.8q5.12-16.12 10.22-32.24a27.41 27.41 0 0 1 2.41-5.94c.71-1.18 1.6-2.25 2.21-3.49 1.55-3.18 1-6.92 1.38-10.44.65-6.21 4.13-11.75 6.24-17.61a81.55 81.55 0 0 1 4.42-9.65 21.16 21.16 0 0 0 1.77-8.19 54.69 54.69 0 0 1 4.16-17.87c1.46-3.48 3.29-6.81 4.38-10.42 1.29-4.24 1.52-8.74 2.68-13a62.48 62.48 0 0 1 4.33-10.64c1.45-3 2.94-6.07 5.33-8.4 3.92-3.82 9.69-5.07 15.16-5.24s11.53.64 16.98.07z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M784.2 482.16q10.56-6.24 20.89-12.88a13.27 13.27 0 0 1-2.61-7.67v-.33c-.1-2.69.92-5-2.47-4.65a64.36 64.36 0 0 0-9.63 2c-.9.23-8.7 3.1-9 2.81a19.2 19.2 0 0 1 3.77 7.06 34.24 34.24 0 0 1 .93 3.85c.68 3.44.71 7.48-1.88 9.81z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M774.75 528.29c.9 7.08 2.43 14.17 2.42 21.29s-1.44 14.37 1.45 20.75c.48 1.08 1.4 1.92 1.5 3.1 4 .69 7.9-1.18 11.71-2.53a47.57 47.57 0 0 1 10.8-2.42c3-.3 6.08-.32 9.06-.89a14.1 14.1 0 0 0 7.83-4c1.83-2 1.81-5 3.09-7.35.65-1.21 1.63-2.2 2.32-3.39a11.89 11.89 0 0 0 .94-8.23 83.59 83.59 0 0 0-2.49-8.08 41.53 41.53 0 0 1-.5-22.68c.84-3.19 2.06-6.32 2.26-9.61a26.73 26.73 0 0 0-.63-6.54c-1.62-8.28-4.79-16.69-11.21-22.16-3.43-2.93-8.07-5.56-8.43-10-1.48-.58-3.07.41-4.34 1.35l-14.26 10.51a5.34 5.34 0 0 0-2 2.09c-.89 2.13 1.16 4.47.83 6.77-.24 1.67-1.66 2.88-2.54 4.32-2.1 3.43-1.42 8.66-4.85 10.77-.31.64-.6 1.3-.86 2a48.64 48.64 0 0 0-2.45 10.8 56.2 56.2 0 0 0 .35 14.13z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M781.42 461.46a19.2 19.2 0 0 1 3.77 7.06 15.81 15.81 0 0 0 3.46.38c5.82 0 9.72-6.67 12.61-11.25-.09-2.69 2.14-1.35-1.25-1a64.36 64.36 0 0 0-9.63 2c-.9.23-8.7 3.1-8.96 2.81z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 788.65,
    cy: 451.17,
    r: 16.36,
    fill: "#a0616a"
  }), React.createElement("rect", {
    x: 807.92,
    y: 509.55,
    width: 12.27,
    height: 23.86,
    rx: 3.33,
    transform: "rotate(-132.39 786.175 495.135)",
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 807.92,
    y: 509.55,
    width: 12.27,
    height: 23.86,
    rx: 3.33,
    transform: "rotate(-132.39 786.175 495.135)",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 789.67,
    cy: 454.24,
    r: 1.36,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M774.75 528.29c12.62-1.86 24.08-9.44 32.85-18.84a14.94 14.94 0 0 0 3.71-5.55 16.76 16.76 0 0 0 .45-5.39l-.21-7.22c-.09-3.16-.22-6.44-1.75-9.2s-4.94-4.75-7.88-3.6c-7.73 3-12.76 9.86-17.18 16.88a71.9 71.9 0 0 1-4.13 6.35c-.75.95-1.77 1.92-3 1.79a2.26 2.26 0 0 1-.75-.2 48.64 48.64 0 0 0-2.45 10.8 56.2 56.2 0 0 0 .34 14.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M773.62 486.13a20.74 20.74 0 0 1 3.42-7.5c4.89-7.65 10.39-15.12 13-23.83-3.81.69-4.41 7.25-8.27 7.54l.3-4.73c0-.8 0-1.77-.65-2.19s-1.81.13-2.24.92-.52 1.75-.92 2.56-1.34 1.53-2.17 1.17l-.34-1.57a2.4 2.4 0 0 0-2.89 2.44 7.24 7.24 0 0 1-.43-2.35c-1.71-.32-2.95 1.57-3.56 3.2a75.93 75.93 0 0 0-2.94 11.25l-1.57 7.61c-.55 2.63-1.09 5.26-1.45 7.91a57.3 57.3 0 0 0 1.1 21.08 68 68 0 0 0 6.09-3.81c1.51-1.28 3.2-2.73 3.77-4.68 1.41-4.92-1.08-10.07-.25-15.02z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M801.92 476.45c2.94-1.15 6.35.84 7.88 3.6s1.66 6 1.75 9.2l.2 7.24a16.51 16.51 0 0 1-.44 5.39 15.12 15.12 0 0 1-3.7 5.55c-9.7 10.39-22.67 18.54-36.87 19.23a2.94 2.94 0 0 1-1.47-.18 3.2 3.2 0 0 1-1-1c-3.17-3.94-6.52-8.47-6-13.49.09-.84 1-1.52 1.3-2.3a20.29 20.29 0 0 1 9.83-10.4l.86-.4a5 5 0 0 0 3.37 2.64c1.2.12 2.23-.84 3-1.79a72.06 72.06 0 0 0 4.13-6.36c4.4-7.09 9.44-13.92 17.16-16.93zM800.91 461.87c-1.39-.72-1.61-2.57-1.75-4.13a40.94 40.94 0 0 0-.83-5.4c-.43-2-1.14-4.06-2.84-5.12a4.15 4.15 0 0 0-6.31 3.09 1.41 1.41 0 0 1-.28.93 1 1 0 0 1-.48.25 3.23 3.23 0 0 1-3.79-2.14c-.29-1-.07-2.29-.78-3.11s-1.55-.8-2.24-1.34a3.89 3.89 0 0 1-1.13-3.2c0-1.49.2-3.27-1-4.19-1.81-1.41-4.53.83-6.66 0a3.27 3.27 0 0 1-1.83-3.19 7.92 7.92 0 0 1 1.3-3.66 30.72 30.72 0 0 1 4.49-5.91c0 .44.69.39 1.07.15l3.16-1.92a.85.85 0 0 0 .25.91 5.43 5.43 0 0 1 2.59-1.4 1.9 1.9 0 0 1 2.21 1.49l4-1.73a.83.83 0 0 1 1.07.11c1.44 1 3.28 1.29 5 1.69s3.55 1.09 4.47 2.61a10.79 10.79 0 0 0 1.25 2.2 4.67 4.67 0 0 0 1.51.89 26.2 26.2 0 0 1 6.3 3.55 11.88 11.88 0 0 1 4.09 5.86c1.08 3.89-.48 8-2.29 11.59a74.25 74.25 0 0 1-4.64 7.95c-.64 1-1.52 2.89-2.55 3.47a4.78 4.78 0 0 1-3.36-.3z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M772.85 433.43c2.13.82 4.85-1.42 6.66 0 1.17.92 1 2.7 1 4.19a3.89 3.89 0 0 0 1.13 3.2c.69.54 1.67.67 2.24 1.34s.49 2.07.78 3.11a3.23 3.23 0 0 0 3.79 2.14 1 1 0 0 0 .48-.25 1.41 1.41 0 0 0 .28-.93 4.15 4.15 0 0 1 6.31-3.09c1.7 1.06 2.41 3.16 2.84 5.12a40.94 40.94 0 0 1 .83 5.4c.14 1.56.36 3.41 1.75 4.13a4.78 4.78 0 0 0 3.42.3c1-.58 1.91-2.5 2.55-3.47a74.25 74.25 0 0 0 4.64-8 24.77 24.77 0 0 0 2.46-6.8c.72 3.68-.76 7.5-2.46 10.89a74.25 74.25 0 0 1-4.64 7.95c-.64 1-1.52 2.89-2.55 3.47a4.78 4.78 0 0 1-3.42-.3c-1.39-.72-1.61-2.57-1.75-4.13a40.94 40.94 0 0 0-.83-5.4c-.43-2-1.14-4.06-2.84-5.12a4.15 4.15 0 0 0-6.31 3.09 1.41 1.41 0 0 1-.28.93 1 1 0 0 1-.48.25 3.23 3.23 0 0 1-3.79-2.14c-.29-1-.07-2.29-.78-3.11s-1.55-.8-2.24-1.34a3.89 3.89 0 0 1-1.13-3.2c0-1.49.2-3.27-1-4.19-1.81-1.41-4.53.83-6.66 0a3.27 3.27 0 0 1-1.83-3.19 5.82 5.82 0 0 1 .5-2.09 2.71 2.71 0 0 0 1.33 1.24z",
    opacity: 0.1
  }));
};
UndrawCalling.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawCalling;